import { atom, selector } from "recoil";
import { PatientInfo } from "../../types/wrapper.types";

export const patientInfoState = atom<PatientInfo>({
    key: 'patientInfoState',
    default: {
        firstName: '',
        lastName: '',
        tin: '',
        birthDay: '',
        surgeryDate: '',
        uuid: ''
    },
    effects: [
        ({ setSelf, onSet }) => {
            const stored = localStorage.getItem('patientData');
            if (stored) {
                try {
                    const parsed = JSON.parse(stored);
                    const patientData = parsed.data || parsed;
                    setSelf({
                        firstName: patientData.firstName || '',
                        lastName: patientData.lastName || '',
                        tin: patientData.tin || '',
                        birthDay: patientData.birthDay || '',
                        surgeryDate: patientData.surgeryDate || '',
                        uuid: patientData.patientUuid || patientData.uuid || '',
                    });
                } catch {
                    // corrupted data → reset
                    localStorage.removeItem('patientData');
                    setSelf({
                        firstName: '',
                        lastName: '',
                        tin: '',
                        birthDay: '',
                        surgeryDate: '',
                        uuid: ''
                    });
                }
            }

            onSet((value) => {
                localStorage.setItem('patientData', JSON.stringify({ data: value }));
            });
        },
    ],
});


export const recountAlertAlarmState = atom({
    key: 'recountAlertAlarmState',
    default: {
        status: false,
        recount: {
            title: '',
        },
    },
});